import { TextKey } from '@mews-commander/enums';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { openPanel } from '../../../../trackingConsent';
import { SecurityCard } from '../SecurityCard';

export const CookiesSettings = () => {
    const dispatch = useCommanderThunkDispatch();
    const handleClick = () => dispatch(openPanel());

    return <NewDesignsCookiesSettings onClick={handleClick} />;
};

interface CookiesSettingsProps {
    onClick: () => void;
}

const NewDesignsCookiesSettings = ({ onClick }: CookiesSettingsProps) => (
    <SecurityCard
        onClick={onClick}
        primaryText={TextKey.CookiePreferencesTitle}
        secondaryText={TextKey.CookiePreferencesDescription}
    />
);
